import {BrowserRouter, Routes, Route} from "react-router-dom"
import Home from "./components/Home"
import ChatPage from "./components/ChatPage";
import socketIO from "socket.io-client"

const socket = socketIO.connect("http://localhost:4000")
// socket.on("message",function(e){
//    console.log(e);
// })
function App() {
  return (
    <BrowserRouter>
        <div>
          <Routes>
            {/* <Route path="/" element={<Home socket={socket}/>}></Route> */}
            <Route path="/" element={<ChatPage socket={socket}/>}></Route>
          </Routes>
    </div>
    </BrowserRouter>
    
  );
}

export default App;